import type { AnyRemoteEnvelope, RemoteConnectionStatus, RemotePresenceState } from '../../types/presentationRemote';

/**
 * 리모컨 "온라인(다른 기기)" 경로 공통 인터페이스.
 * presentationRemoteChannel 이 로컬(BroadcastChannel) 경로와 합쳐서 사용한다.
 */
export interface OnlineTransportCallbacks {
  /** 받은 원본 envelope (검증·중복 제거는 호출 측) */
  onEnvelope: (raw: unknown) => void;
  /** 온라인으로 보이는 참가자 목록 (나 포함 가능 — 호출 측에서 제외) */
  onPresence: (list: RemotePresenceState[]) => void;
  onStatus: (status: RemoteConnectionStatus) => void;
}

export interface OnlineTransportOptions {
  userId: string;
  sessionId: string;
}

export interface OnlineTransport {
  /** 연결 시작(이미 시작됐으면 무시) */
  start: () => void;
  /** 연결 해제(다시 start 가능) */
  stop: () => void;
  /** 송신 가능 상태 */
  isReady: () => boolean;
  send: (env: AnyRemoteEnvelope) => Promise<boolean>;
  /** 내 presence 상태 — 구현이 중복 제거·디바운스 */
  track: (state: RemotePresenceState) => void;
  /** 사용자가 누른 '다시 연결' — 중지 상태(halted 등) 해제 후 즉시 재연결 */
  reconnect: () => void;
  /** 완전 종료(리스너 해제) */
  dispose: () => void;
}

export const ONLINE_LOG_PREFIX = '[presentation-remote]';
export function onlineWarn(...args: unknown[]) {
  try {
    // eslint-disable-next-line no-console
    console.warn(ONLINE_LOG_PREFIX, ...args);
  } catch {
    /* ignore */
  }
}

/** presence 비교용 (lastSeen 등 시각 필드 제외) */
export function presenceSignature(s: RemotePresenceState | null): string {
  if (!s) return '';
  const { lastSeen: _ls, isLocal: _il, ...rest } = s;
  return JSON.stringify(rest);
}
